import { Link } from "react-router-dom";
import React from "react";

import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

import { CardHeading } from "../../UI/Headings";
import images from "../../../utils/images";
import { providerRoute } from "../../../config/roles";

const ClinicalAssessmentCard = (props) => {
  const { type } = props;
  let cardText = "";

  if (type === "initial") {
    cardText = " Clinical Assessment for the Patient";
  } else {
    cardText = " Clinical Outcome Assessment for the Patient";
  }

  return (
    <DashboardCard2 classNameChildren="tw:flex tw:items-center">
      <div className="d-flex align-items-center">
        <img
          src={images("./common/clinical_assessment_icon.svg")}
          alt="90 Days Plan"
          className="PatientProfile__90DaysPlan img-fluid"
          width="39px"
        />

        <CardHeading
          text={(props.done ? "View" : "Complete") + cardText}
          className="d-lg-inline-block ml-2 pl-2 fs-14 fs-lg-16 mb-0"
        />
      </div>

      <div className="ml-auto mt-3 mt-lg-0">
        <div className="d-block text-right">
          <Link
            style={{ color: "white" }}
            className="ClinicalAssessment_Btn Btn Btn--pri Btn-sm"
            to={`${providerRoute}/patient/${props.patientId}/clinical_assessment?type=${type}`}
          >
            Clinical Assessment
          </Link>
        </div>
      </div>
    </DashboardCard2>
  );
};

export default ClinicalAssessmentCard;
